@if (!linkCardSubcategories) {
  <ul class="c__wrapper is-m" sd-list-inline>
    @for (subcategory of subcategories; track subcategory) {
      <li class="{{subcategory.isLarge ? 'is-large' : ''}}">
        <article>
          <sd-subcategory
            [brand]="brand ? brand : subcategory?.brand"
            [isLoading]="isLoading"
            [contentThemesConfig]="contentThemesConfig"
            (subCatClicked)="onSubCatLinkClick($event)"
            [data]="subcategory"
            [isLarge]="subcategory.isLarge"
          />
        </article>
      </li>
    }
    @if (pushTemplate) {
      <li>
        <ng-container *ngTemplateOutlet="pushTemplate" />
      </li>
    }
  </ul>
}
@if (linkCardSubcategories) {
  <ul class="c__wrapper is-m" sd-list-inline>
    @for (subcategory of subcategories; track subcategory) {
      <li>
        <article>
          <sd-push-card
            [indexFollow]="subcategory?.indexFollow !== undefined ? subcategory?.indexFollow : true"
            [brand]="brand ? brand : subcategory?.brand"
            [isLoading]="isLoading"
            [textConfig]="positionEnum.center"
            [mediaConfig]="positionEnum.top"
            (clicked)="onSubCatLinkClick($event)"
            [pushSize]="pushSizeEnum.xxs"
            [hideButtonLink]="true"
            [push]="{media: subcategory?.image, richParagraph: {heading: {data: {title: subcategory?.link?.linkName, brandLogo: subcategory?.brandLogo?.media ? {media: subcategory?.brandLogo?.media} : null}}, links: [{url: subcategory?.link?.url, linkName: subcategory?.link?.linkName}]}}"
            [titleLevel]="4"
            [mediaAsBackground]="false"
            [imageRatio]="imageRatioEnum.r16_9"
            [themesConfig]="themesEnum.light"
          />
        </article>
      </li>
    }
  </ul>
  @if (pushTemplate) {
    <ng-container *ngTemplateOutlet="pushTemplate" />
  }
}
